import React from 'react';
import logo from '../Images/logo.png'
import { Link } from 'react-router-dom'
import { motion} from 'framer-motion'

function Navigation() {
  return (
    <motion.div className='navigation row mt-3' style={{backgroundColor:""}}
        variants={{
            hidden:{opacity:0,y:-50},
            visible:{opacity:1,y:0}
        }}
        initial="hidden"
        animate="visible"
        transition={{duration:2,delay:0}}
    >
        <div className='col-lg-1'></div>
        <div className='col-lg-2 d-flex justify-content-center align-items-center'>
            <Link to='/'>
                <img src={logo} style={{width:"150px"}} alt="logo"></img>
            </Link>
        </div>
        <div className='col-lg-2 col-1'></div>
        <div className='col-lg-5 col-10 mt-2 d-flex justify-content-evenly align-items-center'>
            <div className='d-flex justify-content-evenly align-items-center rounded-pill' style={{height:"50px",width:"100%",border:"1px solid", borderRadius:"30%",backgroundColor:"#1D1D1D"}}>
                <div>
                    <Link to='/' className='text-decoration-none' style={{color:"white"}}>
                        <strong>Home</strong>
                    </Link>
                </div>
                <div>
                    <Link to='/About' className='text-decoration-none' style={{color:"white"}}>
                        <strong>About</strong>
                    </Link>
                </div>
                <div>
                    <Link to='/Registration' className='text-decoration-none' style={{color:"white"}}>
                        <strong>Registration</strong>
                    </Link>
                </div>
                <div>
                    <Link to='/Contact' className='text-decoration-none' style={{color:"white"}}>
                        <strong>Contact</strong>
                    </Link>
                </div>
            </div>
        </div>
        <div className='col-lg-2 col-1'></div>
    </motion.div>
  )
}

export default Navigation